export default "__VITE_ASSET__bf5c2b93__"